import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { BUTTON_HEIGHT_24, BUTTON_HEIGHT_32 } from '../../../Button'
import { ButtonSelect, SelectDropdownListItem } from '../../../Select'
import {
  REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_CONTACT_TYPE_KEY,
  REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_FOLDER_KEY,
} from '../RequestProfileTabEmails.constants'
import {
  getRequestProfileTabEmailsContactTypeOptions,
  getRequestProfileTabEmailsFolderOptions,
  getRequestProfileTabEmailsSelectedOption,
} from '../RequestProfileTabEmails.utils'

import { RequestProfileTabEmailsSubTabsValueItem } from './RequestProfileTabEmailsSubTabsValueItem'

import * as styles from './RequestProfileTabEmailsSubTabs.module.css'

function RequestProfileTabEmailsSubTabs({
  activeSubTab,
  disabled,
  foldersUnreadCount,
  onSetActiveSubTab,
}) {
  const { t } = useTranslation()

  const contactTypeOptions = getRequestProfileTabEmailsContactTypeOptions({ t })

  const folderOptions = getRequestProfileTabEmailsFolderOptions({
    foldersUnreadCount,
    t,
  })

  const contactTypeValue = getRequestProfileTabEmailsSelectedOption({
    activeSubTab,
    options: contactTypeOptions,
    subTabKey: REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_CONTACT_TYPE_KEY,
  })

  const folderValue = getRequestProfileTabEmailsSelectedOption({
    activeSubTab,
    options: folderOptions,
    subTabKey: REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_FOLDER_KEY,
  })

  function handleSelectContactType(option) {
    onSetActiveSubTab({
      ...activeSubTab,
      [REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_CONTACT_TYPE_KEY]: option.value,
    })
  }

  function handleSelectFolder(option) {
    onSetActiveSubTab({
      ...activeSubTab,
      [REQUEST_PROFILE_TAB_EMAILS_SUB_TAB_FOLDER_KEY]: option.value,
    })
  }

  return (
    <div className={styles.subTabs}>
      <ButtonSelect
        className={styles.subTabSelect}
        controlProps={{
          className: styles.subTabContentType,
          contentProps: {
            ValueItem: RequestProfileTabEmailsSubTabsValueItem,
            valueItemProps: {
              className: styles.subTabValueItem,
            },
          },
          height: BUTTON_HEIGHT_32,
          indicatorsProps: {
            ButtonClear: null,
            buttonArrowProps: {
              height: BUTTON_HEIGHT_24,
            },
          },
        }}
        disabled={disabled}
        dropdownFloatingConfig={{
          dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
          maxWidthByRef: false,
        }}
        dropdownProps={{
          className: styles.dropdown,
        }}
        listProps={{
          Item: SelectDropdownListItem,
          headerProps: {
            Search: null,
          },
          itemProps: {
            Content: RequestProfileTabEmailsSubTabsValueItem,
            contentProps: {
              className: styles.dropdownItemContent,
            },
          },
        }}
        options={contactTypeOptions}
        value={contactTypeValue}
        onSelectItem={handleSelectContactType}
      />
      <ButtonSelect
        className={styles.subTabSelect}
        controlProps={{
          className: styles.subTabFolder,
          contentProps: {
            ValueItem: RequestProfileTabEmailsSubTabsValueItem,
            valueItemProps: {
              className: styles.subTabValueItem,
            },
          },
          height: BUTTON_HEIGHT_32,
          indicatorsProps: {
            ButtonClear: null,
            buttonArrowProps: {
              height: BUTTON_HEIGHT_24,
            },
          },
        }}
        disabled={disabled}
        dropdownFloatingConfig={{
          dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
          maxWidthByRef: false,
        }}
        dropdownProps={{
          className: styles.dropdown,
        }}
        listProps={{
          Item: SelectDropdownListItem,
          headerProps: {
            Search: null,
          },
          itemProps: {
            Content: RequestProfileTabEmailsSubTabsValueItem,
            contentProps: {
              className: styles.dropdownItemContent,
            },
          },
        }}
        options={folderOptions}
        value={folderValue}
        onSelectItem={handleSelectFolder}
      />
    </div>
  )
}

export default RequestProfileTabEmailsSubTabs
